import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import i18n from 'i18n-js';
import { Element, fullWidth, notchTop } from '@components/frame';
import BackButton from '@components/common/backButton';

interface NoDataProps {
  C: ColorFunction;
  withoutBackButtonForNoData: boolean;
  shouldUseColorWrapper?: boolean;
  bg?: string;
}

const NoData: FC<NoDataProps> = ({ C, withoutBackButtonForNoData, shouldUseColorWrapper = true, bg = 'Background/Light/System' }) => {
  return (
    <View
      style={{
        backgroundColor: !shouldUseColorWrapper ? bg : C(bg),
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* {!withoutBackButtonForNoData && (
        <View style={{ width: fullWidth, height: '100%', position: 'absolute' }}>
          <Element
            {...{
              config: {
                position: {
                  left: 4,
                  top: notchTop,
                },
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }}
          >
            <BackButton />
          </Element>
        </View>
      )} */}
      <Text style={{ color: C('Label/Light/Primary') }}>{i18n.t('No data')}</Text>
    </View>
  );
};

export default NoData;
